import axios from '../utils/axiosConfig';

interface DeregisteredAthlete {
  _id: string;
  competition: string;
  club: string;
  originalAthleteId?: string;
  firstname: string;
  surname: string;
  age: number;
  gender: string;
  competitionGroup: string;
  competitionGroupName: string;
  type: 'Elite' | 'Basis';
  deregisteredAt: string;
  reason?: string;
}

const deregistrationService = {
  // Deregister an athlete from a competition
  deregisterAthlete: async (
    competitionId: string,
    clubId: string,
    athleteId: string,
    reason?: string
  ): Promise<DeregisteredAthlete> => {
    try {
      const response = await axios.post(
        `/api/deregistrations/${competitionId}/${clubId}/athlete/${athleteId}`,
        { reason }
      );
      return response.data.deregisteredAthlete;
    } catch (error) {
      throw error;
    }
  },

  // Get all deregistered athletes for a competition
  getDeregisteredAthletes: async (
    competitionId: string,
    clubId: string
  ): Promise<DeregisteredAthlete[]> => {
    try {
      const response = await axios.get(
        `/api/deregistrations/${competitionId}/${clubId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Check if an athlete is deregistered
  isAthleteDeregistered: async (
    competitionId: string,
    clubId: string,
    athleteId: string
  ): Promise<{ isDeregistered: boolean; deregisteredAthlete?: DeregisteredAthlete }> => {
    try {
      const response = await axios.get(
        `/api/deregistrations/${competitionId}/${clubId}/athlete/${athleteId}/check`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default deregistrationService;
export type { DeregisteredAthlete };